import { Component, OnInit, Input } from "@angular/core";
import { FactorService } from "src/services/evaluacion/factor.service";
import { CatalogosService } from "src/services/catalogos/catalogos.service";
import { AppComponent } from "src/app/app.component";
import { SweetServices } from "src/services/sweet.services";
import { SessionSotrageService } from "src/services/session-sotrage.service";
import { Factores } from "src/app/model/evaluacion/factores.model";
import { ModificarFactores } from "src/app/model/evaluacion/modificardactores.model";
import { FactoresEBR } from "src/app/model/evaluacion/factoresEBR.model";
import { DetalleFactorEBR } from "src/app/model/evaluacion/factoresEBR.model";
import { NgForm } from "@angular/forms";

@Component({
  selector: "app-factors-generic",
  templateUrl: "./factors.component.html",
  styleUrls: ["./factors.component.css"],
})
export class FactorsComponent implements OnInit {
  // tslint:disable-next-line: no-input-rename
  @Input("tippRiesgo") tippRiesgo: string;

  factores: Factores;
  modificarFactores: ModificarFactores;

  total: number;
  factoresResultados: any[];
  factoresPorRiesgoResultados: any[];
  totalRegistros: number;
  numPage: number;
  contador: number;
  factorSeleccionado: string;
  tablaSeleccionada: string;
  // #region Catálogos
  riesgos: any[];
  probabilidades: any[];
  // #endregion Catálogos

  // #region  EBR Base
  esEBR: boolean;
  esPorcentajeCorrecto: boolean;
  ponderadores = [];
  showBuscar: boolean;
  detalleEBR: FactoresEBR;
  lstFactoresEBR: DetalleFactorEBR[];
  objFactorEBR: DetalleFactorEBR;
  NombreFactor: string;
  // #endregion  EBR Base

  constructor(
    private factorService: FactorService,
    private catalogService: CatalogosService,
    private main: AppComponent,
    private alerta: SweetServices,
    private ssstorage: SessionSotrageService,
  ) {
    this.factores = new Factores();
    this.modificarFactores = new ModificarFactores(
      ssstorage.getCurrentSession().usuarioId,
    );
    this.total = 0;
    this.totalRegistros = 0;
    this.numPage = 0;
    this.contador = 1;
    this.showBuscar = false;
    this.esPorcentajeCorrecto = false;
    this.lstFactoresEBR = [];
  }

  ngOnInit() {
    this.buscarFactores();
    this.esEBR = this.tippRiesgo == "RiesgoEbrId" ? true : false;
    this.riesgos = this.esEBR
      ? this.catalogService.getRiesgo()
      : this.catalogService.getRiesgoComplete();
    this.probabilidades = this.catalogService.getProbabilidad();
  }

  buscarFactores() {
    this.factorService.obtenerFactores(this.tippRiesgo).subscribe(
      (response) => {
        if (response.isCorrect == "true") {
          this.factoresResultados = response.data.info.result;
          setTimeout(() => {
            this.main.loading = false;
          }, 1500);
        } else {
          this.main.loading = false;
          this.alerta.AlertaError(response.message);
        }
      },
      (err) => {
        this.main.loading = false;
        this.alerta.AlertaError(err);
      },
    );
  }

  buscarElegirFactores() {
    this.factores.Pagina = 1;
    this.factores.Tabla = this.factorSeleccionado;
    this.elegirFactor(this.factorSeleccionado);
  }

  elegirFactor(factor: string) {
    this.numPage = 1;
    var objEncontrado = this.factoresResultados.find(
      (objeto) => objeto.factor === factor,
    );

    if (typeof objEncontrado === "undefined") {
      objEncontrado = this.factoresResultados.find(
        (objeto) => objeto.tabla === factor,
      );
    }

    this.factorSeleccionado = factor;
    this.factores.factorId = objEncontrado.factorId;
    this.factores.Tabla = objEncontrado.tabla;
    this.tablaSeleccionada = this.factores.Tabla;
    if (factor != "") {
      this.main.loading = true;
      this.factorService
        .obtenerRiesgosPorFactor(this.factores)
        .subscribe((response) => {
          this.factores.Tabla = objEncontrado.tabla;

          if (response.isCorrect == "true") {
            if (response.data.total == 0) {
              this.factoresPorRiesgoResultados = [];

              this.total = 0;
              this.numPage = 0;
              this.main.loading = false;
              this.alerta.AlertaSinResultados(response.message);
            } else {
              this.factores.Tabla = this.factorSeleccionado;
              this.total = response.data.total;
              this.factoresPorRiesgoResultados = response.data.info.result;
              this.numPage = Math.ceil(this.total / 15);
              this.limitToMax();
              this.main.loading = false;
            }
          } else {
            this.factoresPorRiesgoResultados = [];
            this.total = 0;
            this.numPage = 0;
            this.main.loading = false;
            this.alerta.AlertaError(response.message);
          }
        });
      this.showBuscar = true;
    } else {
      this.factoresPorRiesgoResultados = [];
      this.total = 0;
      this.numPage = 0;
      this.showBuscar = false;
      this.factores.Buscar = "";
    }
  }

  paginador(value) {
    if (value) {
      this.factores.Pagina++;
      this.contador++;
    } else {
      this.factores.Pagina--;
      this.contador--;
    }
    if (value) {
      if (this.factores.Pagina >= 1) {
        this.main.loading = true;
        this.elegirFactor(this.factorSeleccionado);
      }
    } else {
      if (this.factores.Pagina >= 1) {
        this.main.loading = true;
        this.elegirFactor(this.factorSeleccionado);
      }
    }
  }

  //Eliminar más adelante riesgoEbrId al no utilizarse en ese método
  modificarRiesgo(id, factor, riesgoId, riesgoEbrId, probabilidadId) {
    this.modificarFactores.Id = +id;
    this.modificarFactores.Factor = factor;
    this.modificarFactores.Tabla = this.factores.Tabla;
    this.modificarFactores.RiesgoId = +riesgoId;
    this.modificarFactores.ProbabilidadId = +probabilidadId;
  }

  actualizarRiesgo(formRiesgo: NgForm) {
    this.modificarFactores.RiesgoId = +this.modificarFactores.RiesgoId;
    this.modificarFactores.RiesgoEbrId = +this.modificarFactores.RiesgoEbrId;
    this.main.loading = true;
    this.factorService.modificarRiesgo(this.modificarFactores).subscribe(
      (response) => {
        this.main.loading = false;
        if (response == null) {
          this.main.loading = false;
          this.alerta.AlertaError(
            "Existe un error, si persiste contacte al administrador del Sitio.",
          );
          this.factores.Pagina > 1
            ? this.factores.Pagina--
            : (this.factores.Pagina = 1);
        } else if (response.isCorrect === "false") {
          this.main.loading = false;
          this.factores.Pagina > 1
            ? this.factores.Pagina--
            : (this.factores.Pagina = 1);
          this.alerta.AlertaError(response.message);
        } else {
          document.getElementById("closeModal").click();
          this.alerta.AlertaSuccessTimer(response.message);

          setTimeout(() => {
            this.elegirFactor(this.factorSeleccionado);
            this.alerta.AlertaToastSuccess(response.message);
          }, 1500);
        }
      },
      (err) => {
        this.main.loading = false;
        this.alerta.AlertaCatch(err);
      },
    );
  }

  // #region EBR Base inicio
  limitToMax(): void {
    const sumaPorcentaje: number = this.factoresPorRiesgoResultados.reduce(
      (acumulador, item) => acumulador + item.valorRiesgo,
      0,
    );
    const maxValue = 100.0;
    this.esPorcentajeCorrecto = sumaPorcentaje != maxValue ? false : true;
  }

  elegirFactorCombo(factor: string) {
    this.factores.Tabla = factor;
    this.factores.Buscar = "";
    this.factores.Pagina = 1;

    var objfactor = this.factoresResultados.filter((x) => x.factor === factor);
    objfactor.forEach((value) => {
      this.NombreFactor = value.factor;
      if (value.esEditable === 1) {
        this.elegirFactor(this.factores.Tabla);
      } else {
        this.factoresPorRiesgoResultados = [];
        this.total = 0;
        this.numPage = 0;
        this.showBuscar = false;
        this.factores.Buscar = "";
        this.alerta.AlertaSinResultados(
          "El parametro " + factor + " no es editable",
        );
      }
    });
  }

  guardarCambiosFactorEBR() {
    this.detalleEBR = new FactoresEBR();
    this.detalleEBR.tabla = this.tablaSeleccionada;
    this.detalleEBR.lstFactores = this.lstFactoresEBR;
    this.detalleEBR.EsEBR = this.esEBR ? 1 : 0;

    this.main.loading = true;
    this.factorService.modificarRiesgoFactoresMasivo(this.detalleEBR).subscribe(
      (response) => {
        this.main.loading = false;
        if (response == null) {
          this.alerta.AlertaError(
            "Existe un error, si persiste contacte al administrador del Sitio.",
          );
          this.factores.Pagina > 1
            ? this.factores.Pagina--
            : (this.factores.Pagina = 1);
        } else if (response.isCorrect === "false") {
          this.factores.Pagina > 1
            ? this.factores.Pagina--
            : (this.factores.Pagina = 1);
          this.alerta.AlertaError(response.message);
        } else {
          this.main.loading = false;
          this.alerta.AlertaSuccessTimer(response.message);
          setTimeout(() => {
            this.elegirFactor(this.factorSeleccionado);
          }, 1500);
        }
      },
      (err) => {
        this.main.loading = false;
        this.alerta.AlertaCatch(err);
      },
    );
  }

  seleccionarCambioRiesgoFactor(idFactor: number, RiesgoId: number) {
    this.objFactorEBR = new DetalleFactorEBR();
    this.objFactorEBR.id = idFactor;
    this.objFactorEBR.riesgoId = RiesgoId;

    // Si el registro ha sido cargado previamente, primero lo eliminamos
    const indice = this.lstFactoresEBR.findIndex(
      (item) => item.id === idFactor,
    );
    if (indice !== -1) {
      this.lstFactoresEBR.splice(indice, 1);
    }
    //Despues agregamos el nuevo objeto
    this.lstFactoresEBR.push(this.objFactorEBR);
  }
  // #endregion EBR Base cierre
}
